$(document).on('change', '.modifier_check_box', function () {
  var item_id = get_item_id(this)[0];
  var key = get_item_id(this)[1];
  var modifier_id = $(this).data('modifier-id');
  var modifier_set_id = $(this).data('modifier-set-id');
  var maximum_allowed = $(this).data('maximum-allowed');
  check_all_conditions_are_satisfied(item_id, modifier_id, modifier_set_id, maximum_allowed, $(this));
  update_total(item_id, key);
});

function get_item_id(element) {
  return [$(element).data('item-id'), $(element).data('item-id').toString().split('-')[0]];
}

window.check_all_conditions_are_satisfied = function (item_id, modifier_id, modifier_set_id, maximum_allowed, elem) {
  var item_quantity = $('.item-pop-quantity-box-' + item_id).val();
  var all_modifier_sets = $('.item_' + item_id + '_modifier_sets');
  var all_condition_satisfied = [];
  var chosen_variation = $('.item_' + item_id + '_variation:radio:checked')
  var total_variations = $('.item_' + item_id + '_variation:radio')
  if(elem != null){
    if (elem.prop("checked")) {
      $(".item_"+ item_id + "_modifier_" + modifier_id + "_div").removeClass("item_" + item_id + "_modifier_set_" + modifier_set_id + "_div")
    } else if(!elem.prop("checked")){
      $(".item_" + item_id + "_modifier_set_" + modifier_set_id + "_div").removeClass("disable-div")
      $(".item_"+ item_id + "_modifier_" + modifier_id + "_div").addClass("item_" + item_id + "_modifier_set_" + modifier_set_id + "_div")
    }
    if (maximum_allowed != 0 && maximum_allowed == $(".item_" + item_id + "_modifier_set_" + modifier_set_id + "_modifier:checked").length && elem.prop("checked")){
      $(".item_" + item_id + "_modifier_set_" + modifier_set_id + "_div").addClass("disable-div")
    }
  }
  if (chosen_variation.length != 0 && total_variations.length != 0) {
    all_condition_satisfied.push(true);
  }else if (chosen_variation.length == 0 && total_variations.length != 0) {
    all_condition_satisfied.push(false);
  }
  var dup_arr_modifier_set = []
  for (let modifier_set = 0; modifier_set < all_modifier_sets.length; modifier_set++) {
    const element = all_modifier_sets[modifier_set];
    modifier_set_id = element.dataset['modifierSetId']
    if (dup_arr_modifier_set.includes(modifier_set_id)) { continue; }
    console.log("========"+$(element).data('modifier-set-id')+"=========="+check_condition_of_each_modifier(element))
    all_condition_satisfied.push(check_condition_of_each_modifier(element));
    if (all_condition_satisfied.includes(false)) {
      $('.add_item_button_' + item_id).prop('disabled', true);
      break;
    }
    dup_arr_modifier_set.push(modifier_set_id)
  }
  if (all_condition_satisfied.includes(false)) {
    $('.add_item_button_' + item_id).prop('disabled', true);
  } else{
    if (parseInt(item_quantity) >=1 ) {
      $('.add_item_button_' + item_id).prop('disabled', false)
    }
  }
}

function check_condition_of_each_modifier(element) {
  var item_id = $(element).data('item-id');
  var key_or_item_id = $(element).data('key-or-item-id')
  var modifier_set_id = $(element).data('modifier-set-id');
  var added_modifier_sets_elements = $('input.item_' + key_or_item_id +'_modifier_set_' + modifier_set_id + '_modifier:checkbox:checked');
  var added_modifier_sets = 0
  uniq_modifiers = []
  for (let modifier_set = 0; modifier_set < (added_modifier_sets_elements.length); modifier_set++) {
    id = added_modifier_sets_elements[modifier_set].id;
    if (!uniq_modifiers.includes(id)) { 
      added_modifier_sets++; 
      uniq_modifiers.push(id)
    }
  }
  var maximum_allowed_modifiers = $(element).data('modifier-set-maximum-allowed');
  var minimum_required_modifiers = $(element).data('modifier-set-minimum-required');
  if (maximum_allowed_modifiers != '' && minimum_required_modifiers != '') {
    if ((parseInt(minimum_required_modifiers) <= parseInt(added_modifier_sets)) && (parseInt(maximum_allowed_modifiers) >= parseInt(added_modifier_sets))) {
      return true
    } else {
      return false
    }
  } else if(maximum_allowed_modifiers != '' && minimum_required_modifiers == ''){
    console.log("========"+$(element).data('modifier-set-id')+"=========="+parseInt(maximum_allowed_modifiers) >= parseInt(added_modifier_sets))
    if (parseInt(maximum_allowed_modifiers) >= parseInt(added_modifier_sets)) {
      return true
    } else {
      return false
    }
  } else if(maximum_allowed_modifiers == '' && minimum_required_modifiers != ''){
    if (parseInt(minimum_required_modifiers) <= parseInt(added_modifier_sets)) {
      return true
    } else {
      return false
    }
  }
  else if(maximum_allowed_modifiers == '' && minimum_required_modifiers == ''){
    return true
  }
}

$(document).on('change', '.item_variations', function () {
  var item_id = $(this).data('item-id');
  var qty = $(this).data('qty');
  $('.item-pop-quantity-box-' + item_id).attr('max', parseInt(qty))
  check_all_conditions_are_satisfied(item_id, null, null, null, null);
  update_total(item_id);
});

window.update_total = function (item_id, key) {
  var all_modifier_sets = $('.item_' + item_id + '_modifier_sets');
  if (all_modifier_sets.length == 0) {
    all_modifier_sets = $('.item_' + key + '_modifier_sets');
  }
  var dup_arr_total = []
  var modifier_set_wise_total = [];
  for (let modifier_set = 0; modifier_set < (all_modifier_sets.length); modifier_set++) {
    const element = all_modifier_sets[modifier_set];
    total_modifier_set_id = element.dataset['modifierSetId']
    if (dup_arr_total.includes(total_modifier_set_id)) { continue; }
    modifier_set_wise_total.push(parseFloat(calculate_total_of_each_modifier_set(element, item_id, key)));
    dup_arr_total.push(total_modifier_set_id)
  }
  var chosen_variation = $('.item_' + item_id + '_variation:radio:checked')
  var variation_price = parseFloat($(chosen_variation).data('price') || 0);
  var item_price = 0.0
  if (variation_price != '') {
    item_price = variation_price
  } else {
    item_price = $('.item_' + item_id.toString().split("-")[0]
    + '_price').val();
  }
  var total_price = (parseFloat(item_price) + (parseFloat(modifier_set_wise_total.reduce((a, b) => a + b, 0))) || 0) * (parseInt($('.item-pop-quantity-box-' + item_id).val()) || 0)
  $('.add_item_button_' + item_id).val('Add to Cart $' + Number(total_price).toFixed(2));
  $('.add_item_button_' + key).val('Add to Cart $' + Number(total_price).toFixed(2));
  $('.add_item_button_' + item_id).attr('data-disable-with', 'Add to Cart $' + Number(total_price).toFixed(2));
  $('.add_item_button_' + key).attr('data-disable-with', 'Add to Cart $' + Number(total_price).toFixed(2));
}

window.calculate_total_of_each_modifier_set = function (modifier_set, item_id, key) {
  var modifier_set_id = $(modifier_set).data('modifier-set-id');
  var added_modifiers = $('input.item_' + item_id +'_modifier_set_' + modifier_set_id + '_modifier:checkbox:checked')
  if (added_modifiers.length == 0) {
    added_modifiers = $('input.item_' + key +'_modifier_set_' + modifier_set_id + '_modifier:checkbox:checked');
  }
  var total_of_modifier_set = 0.0
  dup_arr_modifier = []
  for (let modifier = 0; modifier < (added_modifiers.length); modifier++) {
    modifier_id = added_modifiers[modifier].id
    if (dup_arr_modifier.includes(modifier_id)) { continue; }
    dup_arr_modifier.push(modifier_id)
    modifier_quantity = $('.modifier-item-' + item_id + '-quantity-box-' + $(added_modifiers[modifier]).data('modifier-id')).val()
    if (parseInt(modifier_quantity) == 0) { modifier_quantity = 1; }
    total_of_modifier_set += (parseFloat($(added_modifiers[modifier]).data('modifier-price')) * parseInt(modifier_quantity));
  }
  return total_of_modifier_set
}
